/** class to define retry param for error scenarios*/
export class RetryOptions {
    maxRetryAttempts: number;
    retryInterval: number; // This reconnect interval is in milliseconds
  
    /**
     * initializes maximumAttempts and retry interval for retry scenarios
     * ```
     * @example
     * this.maxRetryAttempts = 3;
     * this.retryInterval = 1000;
     * ```
     */
    constructor() {
      this.maxRetryAttempts = 3;
      this.retryInterval = 1000;
  
    }
  
    /**
     * defines default http return method
     * @returns - RetryOptions object
     * 
     * ```
     * @example
     * default()
     * ```
     */
    static default(): RetryOptions {
      return new RetryOptions();
    }
  }
  